import { useTranslations } from "next-intl";

const TYPE_KEYS = { course: "typeCourse", retreat: "typeRetreat", bundle: "typeBundle" } as const;
const STATUS_KEYS = {
  published: "statusPublished",
  draft: "statusDraft",
  archived: "statusArchived",
} as const;
const CONTENT_TYPE_KEYS = {
  video: "contentTypeVideo",
  text: "contentTypeText",
  live_session: "contentTypeLiveSession",
  quiz: "contentTypeQuiz",
  assignment: "contentTypeAssignment",
} as const;

function known<T extends object>(map: T, key: string): key is Extract<keyof T, string> {
  return Object.hasOwn(map, key);
}

/** CRS-16: course type, status and lesson type in the instructor's language, never raw enum values. */
export function useCourseLabels() {
  const t = useTranslations("instructor");
  const tTools = useTranslations("instructorCourseTools");
  return {
    type: (value: string) => (known(TYPE_KEYS, value) ? t(TYPE_KEYS[value]) : value),
    status: (value: string) => (known(STATUS_KEYS, value) ? tTools(STATUS_KEYS[value]) : value),
    contentType: (value: string) =>
      known(CONTENT_TYPE_KEYS, value) ? t(CONTENT_TYPE_KEYS[value]) : value,
  };
}
